import * as yup from "yup";

export const workOrderRoleTitleSchema = yup.object().shape({
  name: yup.string().required().label("Name"),
});
